<template>
  <div>

    <div class="package__description" v-if="contactEmail !== ''">
      <p id="outbox-description">{{ $t('outboxSendPackageDescription') }}</p>
    </div>

    <div class="package__actions">
      <el-button
              v-if="contactEmail !== ''"
              type="primary"
              @click="handleSendClick"
              :disabled="sendPackagesDisabled"
              aria-describedby="outbox-description">
        {{ $t('outboxSendPackageEmailButton') }}
      </el-button>
      <div v-else>
        <el-alert
                :title="$t('outboxSendPackageNoEmailError')"
                type="error"
                role="alert"
                :closable="false"
                show-icon>
        </el-alert>
        <p><router-link :to="{name: 'Outbox', params: {step: 'contact'}}">{{ $t('outboxSendPackageGoBackToContactLink') }}</router-link></p>
      </div>
    </div>

    <el-dialog
      :title="$t('outboxSendPackageSuccessModalTitle')"
      :visible.sync="sentDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      v-loading="sentDialogLoading">
      <span>
        <p>{{ $t('outboxSendPackageSuccessModalMessage') }}</p>
        <p v-if="contactName || contactEmail">
          <span class="label">{{ $t('outboxEmailToLabel') }}</span> {{ contactName }}<span v-if="contactName && contactEmail">&lt;</span>{{ contactEmail }}<span v-if="contactName && contactEmail">&gt;</span>
        </p>
        <p v-if="contactPhone">
          <span class="label">{{ $t('outboxEmailPhoneLabel') }}</span> {{ contactPhone }}
        </p>
        <p>
          <span class="label">{{ $t('outboxEmailBody') }}</span>
        </p>
        <p>
          <el-input :value="lastSentUrl" readonly id="offline-url">
            <template slot="append"><el-button type="primary" data-clipboard-target="#offline-url">{{ $t('applicationCopy') }}</el-button></template>
          </el-input>
        </p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleModalDone">{{ $t('outboxSendPackageSuccessModalCloseButton') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import outbox from '@/components/outbox';
  import i18n from '@/configured/vue-i18n';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import Clipboard from 'clipboard';
  const mailtoLink = require('mailto-link');

  export default {
    name: 'OutboxSendPackage',
    data() {
      return {
        sentDialogVisible: false,
        sentDialogLoading: false,
        sendPackagesDisabled: false
      }
    },
    computed: {
      ...mapState(outbox.store.namespace, [
        'contactName',
        'contactEmail',
        'contactPhone',
        'lastSentUrl'
      ]),
      ...mapGetters(outbox.store.namespace, [
        'offlineUrl'
      ])
    },
    methods: {
      handleSendClick,
      ...mapActions(outbox.store.namespace, [
        'sendPackage',
        'clear'
      ]),
      handleModalDone() {
        this.sentDialogVisible = false;
        this.clear();
        this.$router.push({
          name: 'Outbox',
          params: {
            step: 'attachments'
          }
        });
      }
    },
    mounted() { new Clipboard('[data-clipboard-target]'); }
  }

  //////////

  function handleSendClick() {
    this.sentDialogVisible = true;
    this.sentDialogLoading = true;
    this.sendPackagesDisabled = true;

    this.sendPackage().then(()=>{
      this.sentDialogLoading = false;

      const mailto = mailtoLink({
        to: this.contactName && this.contactEmail ? `${this.contactName}<${this.contactEmail}>` : this.contactEmail,
        subject: i18n.i18n.t('outboxEmailSubject'),
        body: `${i18n.i18n.t('outboxEmailBody')}\n\n${this.lastSentUrl}`
      });
      window.location = mailto;
    });
  }
</script>

<style lang="scss" scoped>
  a {
    word-wrap: break-word;
  }

  .package__actions {

    .el-button {
      width: 100%;
    }
  }

  .label {
    font-weight: 700;
    font-size: 13px;
    padding-right: 16px;
    color: #3a3a3a;
  }
</style>
